import { CardWrapper } from '@anm/components/Card';
import TitleBlock from '@anm/components/TitleBlock';
import CardModal from '@anm/components/modals/CardModal';
import { flexCenter } from '@anm/styles/helpers';
import styled from 'styled-components';

export const CardModalWrapper = styled(CardModal)`
  ${CardWrapper} {
    padding: 24px 24px 40px 24px;
  }
`;
export const ItemTitleBlock = styled(TitleBlock)`
  margin-top: 15px;
`;

export const LinkContainer = styled.div`
  ${flexCenter}

  margin-top: 20px;
  > *:first-child {
    margin-right: 20px;
  }
`;
